<template>
	<div class="menuWarp">
		<div class="menu" @click="showMenuList">
    		<img :src="images.menu"/>
    	</div>
    	
		<cube-popup type="my-popup" position="center" :mask-closable="true" ref="menuPopup" :visible="showMenu" :maskClosable="true" @mask-click="close">
		    <div class="menuList safe-top safe-bottom">
		       <ul>
		       		<li v-for="(item, index) in menuData" @click="menuToNext(index)">
		       			<div class="icon">
		       				<img :src="item.icon"/>
		       			</div>
		       			<div class="txt">{{item.title}}</div>
		       		</li>
		       </ul>
		    </div>
		    <div class="closeBtn" @click="close">
       			<img :src="images.del"/>
       		</div>
	    </cube-popup>
	</div>
</template>

<script>
	var img = {};
		img.close = require('../assets/images/faq_del.png');
		img.menu = require('../assets/images/menu.png');
		img.kefu = require('../assets/images/kefu.png');
		img.kefu_hover = require('../assets/images/kefu_hover.png');
		img.qq = require('../assets/images/QQ.png');
		img.QQ_hover = require('../assets/images/QQ_hover.png');
		img.shop = require('../assets/images/shangcheng.png');
		img.shop_hover = require('../assets/images/shangcheng_hover.png');
		img.game = require('../assets/images/youxi.png');
		img.game_hover = require('../assets/images/youxi_hover.png');
		img.del = require('../assets/images/faq_del.png');
		
	export default {
		data() {
		    return {
		    	images:img,
		    	menuData:[{
		    		title:'联系客服',
		    		icon:img.kefu,
		    		hoverIcon:img.kefu_hover
		    	},{
		    		title:'玩家Q群',
		    		icon:img.qq,
		    		hoverIcon:img.QQ_hover
		    	},{
		    		title:'北通商城',
		    		icon:img.shop,
		    		hoverIcon:img.shop_hover
		    	},{
		    		title:'游戏平台',
		    		icon:img.game,
		    		hoverIcon:img.game_hover
		    	}],
		    	showMenu:false,
		    }
		},
	 	mounted() {
		},
	  	methods: {
	  		showMenuList(){
	  			this.showMenu = true;
	  		},
	  		menuToNext(index){
	  			switch(index) {
				     case 0:
				     	//联系客服
				     	window.location.href = 'https://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzkzODAzMjA2Ml80ODM0MzhfNDAwNjc1NDMwMF8yXw'
				        break;
				     case 1:
				     	this.$router.push({name:'playerGroup',params:{}})
				        break;
				     case 2:
				     	window.location.href = 'http://betop-cn.com/shop'
				        break;
				     default:
				     	window.location.href = 'https://www.betopgame.com/#/mSlide'
				} 
	  			
	  		},
		    close(){
		    	this.$refs.menuPopup.hide();
		    	this.showMenu = false;
		    },
	  	},
	}
</script>

<style lang="less">
	.menuWarp{
		.menu{
			position: fixed;
			/*bottom: 80px;*/
			right: 60px;
			width: 120px;
			height: 120px;
			border-radius: 50%;
			z-index: 99;
		}
		
		.menuList{
			ul{
				width:800px;
				/*height:513px;*/
				background:#fff;
				border-radius:30px;
				overflow:hidden;
				
				li{
					position: relative;
					display: flex;
					justify-content: center;
					align-items: center;
					padding:40px 0;
					border: 2px solid #f2f2f2;
					
					.icon{
						margin-right:40px;
						width:50px;
						height:50px
					}
					
					.txt{
						padding-top: 8px;
						font-size: 40px;
						color: #333;
					}
				}
			}
		}
		
		.closeBtn{
			position: absolute;
			top: 50vh;
			width: 100%;
			text-align: center;
			
			img{
				width: 80px;
			}
		}
	}
	
	
</style>


// WEBPACK FOOTER //
// src/components/menuList.vue